import {atom} from 'jotai';

export const newsPostIdAtom = atom<number | undefined>(undefined);
